import { useEffect } from "react"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./useAuth"
import { logger } from "@/utils/logger"
import { toast } from "sonner"
import { queryClient } from "@/lib/react-query"

export const useRealtimeMessages = (conversationId?: string, disabled?: boolean) => {
  const { profile } = useAuth()

  useEffect(() => {
    if (!profile?.id || disabled) return () => {};

    logger.info("Configurando realtime para mensagens", "useRealtimeMessages", {
      conversationId,
      userId: profile.id
    })

    let isMounted = true;

    // Subscription para novas mensagens
    const messagesChannel = supabase
      .channel('messages-changes')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: conversationId ? `conversation_id=eq.${conversationId}` : undefined
        },
        (payload) => {
          if (!isMounted) return;
          logger.info("Nova mensagem recebida", "useRealtimeMessages", payload)
          
          // Invalidar queries relacionadas
          queryClient.invalidateQueries({ queryKey: ["messages"] })
          queryClient.invalidateQueries({ queryKey: ["conversations"] })
          
          // Mostrar notificação se a mensagem não é do usuário atual
          if (payload.new.sender_id !== profile.id) {
            toast.info("Nova mensagem recebida!")
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'messages',
          filter: conversationId ? `conversation_id=eq.${conversationId}` : undefined
        },
        (payload) => {
          if (!isMounted) return;
          logger.info("Mensagem atualizada", "useRealtimeMessages", payload)
          queryClient.invalidateQueries({ queryKey: ["messages"] })
        }
      )
      .subscribe()

    // Subscription para mudanças nas conversas
    const conversationsChannel = supabase
      .channel('conversations-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations'
        },
        (payload) => {
          if (!isMounted) return;
          logger.info("Conversa atualizada", "useRealtimeMessages", payload)
          queryClient.invalidateQueries({ queryKey: ["conversations"] })
        }
      )
      .subscribe()

    return () => {
      logger.info("Removendo subscriptions do realtime", "useRealtimeMessages")
      isMounted = false;
      messagesChannel.unsubscribe()
      conversationsChannel.unsubscribe()
      supabase.removeChannel(messagesChannel)
      supabase.removeChannel(conversationsChannel)
    }
  }, [profile?.id, conversationId, queryClient, disabled])
}